import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';
import { localeFr } from '../../misc';

// Every string for the Reporting and Analytics Portal lives under `reportingPortal` in EN.json and
// FR.json. The French value is the English text until translated, except the menu link and the
// portal heading, which are real French. `menuLabel` is the adminLinks.reportingAndAnalytics text.
export const getReportingStrings = locale => {
  const file = locale === localeFr ? FR : EN;
  return { ...file.reportingPortal, menuLabel: file.adminLinks.reportingAndAnalytics };
};

const useReportingStrings = () => getReportingStrings(useLocaleContext());

export default useReportingStrings;
